import React from "react";

export default function Redirect({ link }) {
  window.location.replace(link);
  return <></>;
}
